<template>
  <div class="solution-page-container">
    <div class="banner-container">
      <div class="title">
        <span class="solution-enter">解决方案</span>
        <span class="solution-enter">Solution</span>
        <span class="solution-enter"
          >根据企业独家定制方案，用成熟的解决方案打造商业价值的裂变</span
        >
      </div>
    </div>
    <div class="solution-page-content-container">
      <div class="solution-page-content-item solution-enter">
        <div class="solution-page-content-item-left">
          <img src="@/assets/image/solution-1.png" alt="" />
        </div>
        <div class="solution-page-content-item-right">
          <div class="solution-content">
            <div class="title">
              <span>企业转型解决方案</span>
            </div>
            <div class="content">
              <span
                >以数据驱动企业现有的内外部资源。辅助软件系统实企业现智能化转型，实现全部资源的配置优化，全方面提升企业数字化经济中的竞争力。</span
              >
            </div>
            <div class="query-btn" @click="goToCasePage">
              <span>查看案例</span>
              <img src="@/assets/image/icon-arrow.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="solution-page-content-item solution-enter">
        <div class="solution-page-content-item-left">
          <div class="solution-content">
            <div class="title">
              <span>教育文娱解决方案</span>
            </div>
            <div class="content">
              <span
                >提供一站式智慧教育解决方案，基于大数据、云计算能力为各种教育场景打造产品。服务于在线教育、学校、科研机构等。</span
              >
            </div>
            <div class="query-btn" @click="goToCasePage">
              <span>查看案例</span>
              <img src="@/assets/image/icon-arrow.png" alt="" />
            </div>
          </div>
        </div>
        <div class="solution-page-content-item-right">
          <img src="@/assets/image/solution-2.png" alt="" />
        </div>
      </div>
      <div class="solution-page-content-item solution-enter">
        <div class="solution-page-content-item-left">
          <img src="@/assets/image/solution-3.png" alt="" />
        </div>
        <div class="solution-page-content-item-right">
          <div class="solution-content">
            <div class="title">
              <span>工业物联网解决方案</span>
            </div>
            <div class="content">
              <span
                >面向企业提供软硬件一体化服务，为企业建立完整的数据平台。为智慧交通、公共平台、智能生产等行业提供端到端物联网解决方案。</span
              >
            </div>
            <div class="query-btn" @click="goToCasePage">
              <span>查看案例</span>
              <img src="@/assets/image/icon-arrow.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="solution-page-content-item solution-enter">
        <div class="solution-page-content-item-left">
          <div class="solution-content">
            <div class="title">
              <span>智慧政务解决方案</span>
            </div>
            <div class="content">
              <span
                >专为政务行业建立创新型的政务服务平台，提升政务处理的时效性、安全性。全面打造“互联网+政务”的服务体系。</span
              >
            </div>
            <div class="query-btn" @click="goToCasePage">
              <span>查看案例</span>
              <img src="@/assets/image/icon-arrow.png" alt="" />
            </div>
          </div>
        </div>
        <div class="solution-page-content-item-right">
          <img src="@/assets/image/solution-4.png" alt="" />
        </div>
      </div>
    </div>
    <contact-us></contact-us>
  </div>
</template>

<script>
import contactUs from "@/components/contactUs";
import scrollReveal from "scrollreveal";
export default {
  components: {
    contactUs,
  },
  data() {
    return {
      scrollReveal: scrollReveal(),
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollReveal.reveal(".solution-enter", {
        duration: 250,
        delay: 0,
        interval: 0,
        origin: "bottom",
        viewOffset: {
          bottom: 100,
        },
        reset: false,
        mobile: false,
        distance: "100px",
        opacity: 0.0,
        easing: "linear",
        scale: 1,
      });
    });
  },
  methods: {
    goToCasePage() {
      this.$router.push("/details?menuIndex=1");
    },
  },
};
</script>

<style lang="scss" scoped>
.solution-page-container {
  .banner-container {
    background: url("../../../assets/image/main-background.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    height: 726px;
    display: flex;
    justify-content: center;
    align-items: center;
    .title {
      // padding-top: 243px;
      span {
        display: block;
        font-family: PingFangSC-Semibold;
        font-size: 40px;
        color: #ffffff;
        text-align: center;
      }
      span + span {
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        color: #0057ff;
        text-align: center;
      }
      span + span + span {
        margin-top: 40px;
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
  .solution-page-content-container {
    max-width: 1200px;
    margin: 75px auto 0;
    .solution-page-content-item {
      margin-bottom: 75px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .solution-page-content-item-left,
      .solution-page-content-item-right {
        .solution-content {
          .title {
            font-family: PingFangSC-Semibold;
            font-size: 30px;
            color: #000000;
          }
          .content {
            margin: 20px 0;
            width: 350px;
            font-family: PingFangSC-Regular;
            font-size: 18px;
            color: #3d3d3d;
            line-height: 28px;
          }
          .query-btn {
            width: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            user-select: none;
            padding: 9px 22px;
            background: #000000;
            border-radius: 20px;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #ffffff;
            img {
              display: block;
              width: 12px;
              height: 12px;
            }
            &:active {
              opacity: 0.7;
            }
          }
        }
        img {
          display: block;
          height: 400px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/details/components/solutionPage.vue